import { Condition } from "./medication-condition-pairs";

export const conditionSearchTerms: Record<Condition, string[]> = {
  [Condition.RHEUMATOID_ARTHRITIS]: [
    "RA",
    "rheumatoid",
    "joint inflammation",
    "autoimmune arthritis",
    "rumatoid",
    "inflammatory arthritis",
  ],
  [Condition.ANKYLOSING_SPONDYLITIS]: [
    "AS",
    "spinal arthritis",
    "spine inflammation",
    "bamboo spine",
    "ankylosing spondilitis",
    "ankilosing",
    "Bechterew's disease",
    "axial spondylitis",
  ],
  [Condition.NON_RADIOGRAPHIC_AXIAL_SPONDYLOARTHRITIS]: [
    "nr-axSpA",
    "axial spondyloarthritis",
    "non-radiographic",
    "axSpA",
    "spondyloarthritis",
  ],
  [Condition.PSORIATIC_ARTHRITIS]: [
    "PsA",
    "psoriasis arthritis",
    "psoriatic",
    "psoriatric",
  ],
  [Condition.ULCERATIVE_COLITIS]: [
    "UC",
    "colitis",
    "inflammatory bowel",
    "IBD",
    "ulcerative colitus",
  ],
  [Condition.CROHNS_DISEASE]: [
    "Crohns",
    "Crohn",
    "inflammatory bowel",
    "IBD",
    "Chrons",
    "Crones",
    "CD",
    "regional enteritis",
  ],
  [Condition.PLAQUE_PSORIASIS]: [
    "psoriasis",
    "skin plaques",
    "PsO",
    "soriasis",
    "psorisis",
  ],
  [Condition.MIGRAINE]: [
    "headache",
    "chronic migraine",
    "severe headache",
    "CGRP",
    "intractable migraine",
    "episodic migraine",
  ],
  [Condition.GOUT]: [
    "uric acid",
    "gouty arthritis",
    "hyperuricemia",
    "tophaceous gout",
    "refractory gout",
    "chronic gout",
    "uncontrolled gout",
  ],
  [Condition.OBESITY]: [
    "weight loss",
    "overweight",
    "BMI",
    "weight management",
    "bariatric",
    "GLP-1",
    "anti-obesity medication",
    "AOM",
    "morbid obesity",
    "weight loss medication",
  ],
  [Condition.PANS]: [
    "Pediatric Acute-onset Neuropsychiatric Syndrome",
    "neuropsychiatric",
    "sudden onset OCD",
    "autoimmune encephalitis",
  ],
  [Condition.PANDAS]: [
    "Pediatric Autoimmune Neuropsychiatric Disorders",
    "strep neuropsychiatric",
    "strep triggered OCD",
  ],
  [Condition.TYPE_2_DIABETES]: [
    "T2D",
    "T2DM",
    "diabetes",
    "type 2",
    "type II diabetes",
    "blood sugar",
    "A1C",
    "HbA1c",
    "DM2",
    "adult onset diabetes",
    "NIDDM",
    "non-insulin dependent diabetes",
  ],
  [Condition.ASTHMA]: [
    "breathing",
    "wheezing",
    "bronchial asthma",
    "reactive airway",
    "severe asthma",
    "eosinophilic asthma",
    "allergic asthma",
    "uncontrolled asthma",
  ],
  [Condition.CSID]: [
    "Congenital Sucrase-Isomaltase Deficiency",
    "sucrase deficiency",
    "sucrose intolerance",
    "sucrase isomaltase",
    "sucrase isomaltase deficiency",
    "disaccharide intolerance",
    "sucrose malabsorption",
  ],
  [Condition.HYPOPHOSPHATASIA]: [
    "HPP",
    "low alkaline phosphatase",
    "soft bones",
    "bone mineralization disorder",
    "hypophosphatesia",
    "hypofosphatasia",
    "hypophosphetasia",
    "hypophospatasia",
    "hypophostatasia",
    "hipophosphatasia",
    "hypophosphatsia",
    "low ALP",
    "metabolic bone disease",
  ],
  [Condition.ATOPIC_DERMATITIS]: [
    "AD",
    "eczema",
    "skin rash",
    "dermatitis",
    "exzema",
    "excema",
    "atopic eczema",
  ],
  [Condition.CHRONIC_RHINOSINUSITIS]: [
    "CRSwNP",
    "nasal polyps",
    "sinus inflammation",
    "chronic sinusitis",
    "rhinosinusitus",
    "nasal polyposis",
    "sinus polyps",
  ],
  [Condition.EOSINOPHILIC_ESOPHAGITIS]: [
    "EoE",
    "swallowing difficulty",
    "esophagus inflammation",
    "eosinophilic",
    "eosinophillic esophagitis",
    "esophagitus",
    "allergic esophagitis",
    "dysphagia",
  ],
  [Condition.PRURIGO_NODULARIS]: [
    "PN",
    "itchy nodules",
    "chronic itch",
    "prurigo",
    "pruigo nodularis",
    "nodular prurigo",
  ],
  [Condition.COPD]: [
    "COPD",
    "chronic bronchitis",
    "emphysema",
    "lung disease",
    "chronic obstructive",
  ],
  [Condition.CHRONIC_SPONTANEOUS_URTICARIA]: [
    "CSU",
    "chronic hives",
    "urticaria",
    "spontaneous hives",
    "urticarea",
    "CIU",
    "chronic idiopathic urticaria",
  ],
  [Condition.BULLOUS_PEMPHIGOID]: [
    "BP",
    "skin blistering",
    "autoimmune blisters",
    "pemphigoid",
    "bullous pemfigoid",
  ],
  [Condition.OBSTRUCTIVE_SLEEP_APNEA]: [
    "OSA",
    "sleep apnea",
    "sleep disorder",
    "sleep",
    "apnea",
    "CPAP",
    "sleep disordered breathing",
  ],
  [Condition.MASH]: [
    "MASH",
    "liver disease",
    "fatty liver",
    "NAFLD",
    "NASH",
    "nonalcoholic steatohepatitis",
    "metabolic liver disease",
    "MASLD",
    "steatotic liver disease",
  ],
  [Condition.LIVER_CANCER]: [
    "HCC",
    "hepatocellular carcinoma",
    "liver tumor",
    "liver transplant",
    "hepatoma",
  ],
  [Condition.BREAST_NERVE_RECONSTRUCTION]: [
    "breast reconstruction",
    "nipple sensation",
    "post-mastectomy nerve repair",
    "sensory restoration",
    "Resensation",
    "neurotization",
  ],
  [Condition.PROSTATE_NERVE_GRAFTING]: [
    "prostatectomy nerve repair",
    "cavernous nerve graft",
    "erectile nerve reconstruction",
    "prostate nerve",
    "radical prostatectomy",
  ],
  [Condition.EXTREMITY_NERVE_REPAIR]: [
    "peripheral nerve repair",
    "hand nerve injury",
    "upper extremity nerve",
    "lower extremity nerve",
    "digital nerve repair",
    "nerve gap",
    "nerve allograft",
    "traumatic nerve injury",
  ],
  [Condition.HEAD_NECK_OMF]: [
    "OMF",
    "head and neck",
    "oral maxillofacial",
    "inferior alveolar nerve",
    "lingual nerve repair",
    "facial nerve repair",
    "head and neck nerve",
    "dental nerve injury",
    "trigeminal nerve",
    "IAN repair",
  ],
};
